/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as QueueDefs from './defs.defs.js'

const $nsid = 'tools.ozone.queue.listQueues'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  enabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  subjectType: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  collection: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  reportTypes: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 10 }),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  queues: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<QueueDefs.QueueView>(
      (() => QueueDefs.queueView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** List all configured moderation queues with statistics. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
